import { jsx } from 'react/jsx-runtime';
import { SvgIcon } from '../../SvgIcon/SvgIcon/index.js';

const IconMediaNext = SvgIcon({
    // eslint-disable-next-line max-len
    children: jsx("path", { d: "M18 5.742a.667.667 0 0 0-.234-.515.668.668 0 0 0-.516-.235.741.741 0 0 0-.54.235.701.701 0 0 0-.21.515v4.125L9.305 4.43c-.672-.516-1.39-.586-2.157-.211C6.383 4.579 6 5.179 6 6.023v11.954c0 .843.383 1.453 1.148 1.828.766.36 1.485.28 2.157-.235l7.195-5.437v4.125c0 .203.07.383.21.539.157.14.337.21.54.21s.375-.07.516-.21a.741.741 0 0 0 .234-.54V5.743z" }),
});

export { IconMediaNext };
